import sx from '../../sx.js';
import styled from 'styled-components';

const StyledButton = styled.button.withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-ek70jg-0"
})(["", ";"], sx);

export { StyledButton };
